import React from 'react'

const CardSilderInformation = () => {
  return (
    <div>CardSilderInformation</div>
  )
}

export default CardSilderInformation